import { Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const StudentInfo = ({
  fulllname,
  nickname,
  course,
}: {
  fulllname: string;
  nickname: string;
  course: string;
}) => {
  const { t } = useTranslation();
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} sm={3}>
        <Typography variant="subtitle1">
          {t("ชื่อ - นามสกุล :")} <b>{fulllname ?? "-"}</b>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={2}>
        <Typography variant="subtitle1">
          {t("ฉายา :")} <b>{nickname ?? "-"}</b>
        </Typography>
      </Grid>
      <Grid item xs={12} sm={4}>
        <Typography variant="subtitle1">
          {t("หลักสูตร :")} <b>{course ?? "-"}</b>
        </Typography>
      </Grid>
    </Grid>
  );
};

export default StudentInfo;
